import { PAGE_SEARCH_PARAMETER } from "constants/common";
import { convertSearchParamsToObject } from "helpers";
import { CategoryTypes } from "modules/categories";

import {
  MAX_PRICE_FILTER_SEARCH_PARAMETER,
  MIN_PRICE_FILTER_SEARCH_PARAMETER,
  STATUS_FILTER_SEARCH_PARAMETER
} from "../constants";
import { ProductStatusFilterValues } from "../product.types";

export const getProductsFiltersAmount = ({
  searchParams,
  filterMinPrice,
  filterMaxPrice
}: {
  searchParams: URLSearchParams;
  filterMaxPrice?: number;
  filterMinPrice?: number;
}) => {
  let amount = 0;
  const {
    [STATUS_FILTER_SEARCH_PARAMETER]: status,
    [CategoryTypes.MAIN_CATEGORY]: mainCategory,
    [CategoryTypes.SUB_CATEGORY]: subCategory,
    [CategoryTypes.SUB_CHILD_CATEGORY]: subChildCategory,
    [MIN_PRICE_FILTER_SEARCH_PARAMETER]: minPrice,
    [MAX_PRICE_FILTER_SEARCH_PARAMETER]: maxPrice,
    [PAGE_SEARCH_PARAMETER]: _page,
    ...rest
  } = convertSearchParamsToObject(searchParams);

  if (status && status !== ProductStatusFilterValues.ALL) {
    amount += 1;
  }

  if (mainCategory || subCategory || subChildCategory) {
    amount += 1;
  }

  if (
    (minPrice && Number(minPrice) !== filterMinPrice) ||
    (maxPrice && Number(maxPrice) !== filterMaxPrice)
  ) {
    amount += 1;
  }

  Object.values(rest).forEach((filterValue) => {
    if (!filterValue) {
      return;
    }

    if (Array.isArray(filterValue)) {
      amount += filterValue.length;
    } else {
      amount += 1;
    }
  });

  return amount;
};
